import './table-description-cell.scss';
import { DynamicPlacementPopover } from '../dynamic-placement-popover/dynamic-placement-popover';
import React from 'react';

interface RowDataDescription {
    description: string;
}

interface TableDescriptionCellProps<T> {
    rowData: T
}

export const TableDescriptionCell = <T extends RowDataDescription>({ rowData }: TableDescriptionCellProps<T>) => {

    const formatDescription = (description: string) => {
        return description?.replaceAll(String.raw`\n`, '\n');
    };

    return <div className={'description-cell'}>
        <DynamicPlacementPopover content={formatDescription(rowData.description)}
                                 overlayClassName="full-description" defaultZonePlacement="bottomLeft"
                                 contentHeight={20}>
            <div className={`description`}>{formatDescription(rowData.description)}</div>
        </DynamicPlacementPopover>
    </div>;
};